module.exports = __webpack_public_path__ + "static/media/logo.a400d907.svg";